import React, { useState } from "react";
import styled, { withTheme } from "styled-components";
import { StyledButton } from "./TopLink";
import ExpandableContent from "./ExpandableContent";
import LinkArrow from "../shared/LinkArrow";

import theme from "../../../styles/theme";

const ArrowWrapper = styled.span`
  position: absolute;
  top: 16px;
  right: 16px;
  transition: transform .5s;
  transform-origin: 25% center;
  transform-origin: center 25%;
  transform: rotate(${(props) => {
    return props.open ? "180deg" : "0deg"
  }});
`;

const RelativeWrapper = styled.div`
  position: relative;
  z-index: 3;
  padding: 8px 12px 16px;
`;

const DropdownContentWrapper = styled.div`
  position: relative;
  width: 100%;
  top: 0;
  z-index: 3;
  max-height: ${props => (props.open ? "110vh" : "0")};
  overflow: hidden;
  transition: max-height 1s ease-out;
  color: ${() => theme.colors.green5};
`;

const DropdownLink = ({
  children,
  className,
  dropDownContent,
  isOpen = false
}) => {
  const [open, setOpen] = useState(isOpen);
  return (
    <span onClick={() => setOpen(!open)}>
      <StyledButton data-label={children} className={className} open={open}>
        {children}
        <ArrowWrapper open={open} className="arrow-wrapper">
          <LinkArrow
            fillColor={open ? theme.colors.green3 : theme.colors.green5}
          />
        </ArrowWrapper>
      </StyledButton>
      <DropdownContentWrapper open={open}>
        <RelativeWrapper>
          <ExpandableContent content={dropDownContent} />
        </RelativeWrapper>
      </DropdownContentWrapper>
    </span>
  );
};

export default withTheme(DropdownLink);
